export class AboutModel {
  AboutText: string = "";
  ContactName: string = "";
  Email: string = "";
  LogoFileId: string = "";
  Phone: string = "";
  TenantName: string = "";
  Url: string = "";
}
